export default __webpack_public_path__ + "static/media/peak.fb8d134c.png";